// God's Eye "view as": see the app exactly as one person does, read-only (the API refuses every write for this token;
// backend platform_ops.install_readonly_guard). Your own session is set aside in localStorage under ge.adminSession
// (not one of the shared-session keys, so it never leaves this browser) and put back by exitViewAs() or when the
// 30-minute token runs out.
const ADMIN = 'ge.adminSession';
const VIEW = 'ge.viewAs';
const KEYS = ['token', 'userName', 'userEmail', 'userRole'];

export function viewAs() {
  try {
    const v = JSON.parse(localStorage.getItem(VIEW) || 'null');
    return v && v.user_id ? v : null;
  } catch (_) { return null; }
}

export function startViewAs({ token, user, expires_at: expiresAt }) {
  if (!viewAs()) {
    const saved = {};
    KEYS.forEach((k) => { saved[k] = localStorage.getItem(k); });
    localStorage.setItem(ADMIN, JSON.stringify(saved));
  }
  localStorage.setItem(VIEW, JSON.stringify({ user_id: user.user_id, username: user.username, expires_at: expiresAt }));
  localStorage.setItem('token', token);
  localStorage.setItem('userName', user.username || '');
  localStorage.setItem('userRole', user.role || 'user');
  localStorage.removeItem('userEmail');
  window.location.href = '/app';
}

export function exitViewAs(goBack = true) {
  const v = viewAs();
  let saved = null;
  try { saved = JSON.parse(localStorage.getItem(ADMIN) || 'null'); } catch (_) { /* gone */ }
  KEYS.forEach((k) => {
    if (saved && saved[k]) localStorage.setItem(k, saved[k]); else localStorage.removeItem(k);
  });
  localStorage.removeItem(ADMIN);
  localStorage.removeItem(VIEW);
  if (goBack) window.location.href = v ? `/app/superadmin?s=users&u=${v.user_id}` : '/app/superadmin';
}
